import React from 'react';
import { Modal, Button, Descriptions, Steps, Divider, message } from 'antd';
import './index.less';

const { Item } = Descriptions;
const { Step } = Steps;

export default ({ modalVisible, formData, onClose }) => {
  const [visible, setViisible] = React.useState(false);
  React.useEffect(() => {
    if (modalVisible) {
      setViisible(true);
    }
  }, [modalVisible]);

  const handleClose = () => {
    setViisible(false);
    onClose && onClose(false);
  };

  // 复制快递单号
  const handleCopyLgsNumber = async () => {
    if (navigator.clipboard && window.isSecureContext) {
      try {
        await navigator.clipboard.writeText(formData.lgsNumber);
        message.success('复制成功');
      } catch (err) {
        console.error('Failed to copy: ', err);
        message.error('复制失败');
      }
    } else {
      let textArea = document.createElement('textarea');
      textArea.value = formData.lgsNumber;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      return new Promise((res, rej) => {
        document.execCommand('copy');
        textArea.remove();
        message.success('复制成功');
      });
    }
  };

  return (
    <>
      <Modal
        title="物流信息"
        visible={visible}
        width={800}
        wrapClassName="logisticsInfo-modal"
        maskClosable={false}
        centered={true}
        onCancel={handleClose}
        footer={[
          <Button type="primary" onClick={handleClose}>
            关闭
          </Button>,
        ]}
      >
        {formData && Object.keys(formData).length ? (
          <>
            <Descriptions bordered={false} column={2}>
              {/* <Item label="订单类型">{formData.docType}</Item> */}
              <Item label="快递单号">
                <span style={{ marginRight: 4 }}>
                  {formData.lgsNumber !== 'null' ? formData.lgsNumber : ''}
                </span>
                {formData.lgsNumber !== 'null' ? (
                  <Button type="primary" size="small" onClick={() => handleCopyLgsNumber()}>
                    复制
                  </Button>
                ) : null}
              </Item>
              <Item label="配送方式">{formData.lgsName || ''}</Item>
              <Item label="收货人">{formData.recvName || ''}</Item>
              <Item label="联系方式">{formData.recvMobile || ''}</Item>
              <Item label="收货地址">{formData.recvAddr || ''}</Item>
              <Item label="订单号">
                {formData.docType}
                {formData.docNo}
              </Item>
            </Descriptions>
            {Array.isArray(formData.tracks) && formData.tracks.length ? (
              <>
                <Divider className="divider-xs" />
                <div className="lgs-step">
                  <Steps progressDot direction="vertical">
                    {formData.tracks.map((item, index) => {
                      return <Step key={index} title={item.context} description={item.time} />;
                    })}
                  </Steps>
                </div>
              </>
            ) : null}
          </>
        ) : null}
      </Modal>
    </>
  );
};
